import { Tabs } from '@ui/lib/park/ui/tabs';
import { OrderType } from '@ui/types/trade';
import { useTranslation } from 'next-i18next';

export const OrderTypeButtonGroup = ({
  orderType,
  setOrderType,
  ...p
}: Omit<Tabs.RootProps, 'value' | 'onValueChange'> & {
  orderType: OrderType;
  setOrderType: (orderType: OrderType) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Tabs.Root
      variant="line"
      animation="none"
      value={orderType}
      onValueChange={(v) => {
        setOrderType(v.value as OrderType);
      }}
      {...p}
    >
      {/* mockup .tp-tab: 40px, 13px/500, inactive muted, active = white text +
          2px acid underline (the indicator carries the accent, not the label).
          px/gap mirror the Long/Short control's border+inner padding so the
          indicator is flush with the segment below (owner request) */}
      <Tabs.List h="40px" px="3px" gap="8px">
        <Tabs.Trigger
          textStyle="v2.ui"
          fontWeight="500"
          h="40px"
          color="v2.text.muted"
          _selected={{ color: 'v2.text.primary !important' }}
          _hover={{ color: 'v2.text.primary', bg: 'transparent' }}
          value={OrderType.MARKET}
          flex={1}
          data-cy="MarketButton"
        >
          {t('common.Market')}
        </Tabs.Trigger>
        <Tabs.Trigger
          textStyle="v2.ui"
          fontWeight="500"
          h="40px"
          color="v2.text.muted"
          _selected={{ color: 'v2.text.primary !important' }}
          _hover={{ color: 'v2.text.primary', bg: 'transparent' }}
          value={OrderType.LIMIT}
          flex={1}
          data-cy="LimitButton"
        >
          {t('common.Limit')}
        </Tabs.Trigger>
        <Tabs.Indicator
          style={{
            // @ts-ignore
            '--transition-property': 'none',
          }}
        />
      </Tabs.List>
    </Tabs.Root>
  );
};
